import { ReactComponent as GroupIcon } from "./group.svg";
import { ReactComponent as LisenceIcon } from "./license.svg";
import { ReactComponent as AssignmentIcon } from "./assignment.svg";
import { ReactComponent as LogoutIcon } from "./logout.svg";
import { ReactComponent as ArrowUpIcon } from "./arrow_up.svg";
import { ReactComponent as ArrowDownIcon } from "./arrow_down.svg";
import { ReactComponent as UnfoldMoreIcon } from "./unfold_more.svg";
import { ReactComponent as AdminPanelSettingsIcon } from "./admin_panel_settings.svg";
import { ReactComponent as NotificationsIcon } from "./notifications.svg";
import { ReactComponent as MonitoringIcon } from "./monitoring.svg";
import { ReactComponent as AccountTreeIcon } from "./account_tree.svg";
import { ReactComponent as ListAltIcon } from "./list_alt.svg";
import { ReactComponent as MoreVertIcon } from "./more_vert.svg";
import { ReactComponent as DirectionsBoatIcon } from "./directions_boat.svg";
import { ReactComponent as SupervisorAccountIcon } from "./supervisor_account.svg";
import { ReactComponent as Diversity3Icon } from "./diversity_3.svg";
import { ReactComponent as BoltIcon } from "./bolt.svg";
import { ReactComponent as SocialLeaderboardIcon } from "./social_leaderboard.svg";
import { ReactComponent as AwardStarIcon } from "./award_star.svg";
import { ReactComponent as ContractIcon } from "./contract.svg";
import { ReactComponent as ContractEditIcon } from "./contract_edit.svg";
import { ReactComponent as ManufacturingIcon } from "./manufacturing.svg";
import { ReactComponent as NotificationsMultipleIcon } from "./notification_multiple.svg";
import { ReactComponent as TvSigninIcon } from "./tv_signin.svg";
import { ReactComponent as CalendarMonthIcon } from "./calendar_month.svg";
import { ReactComponent as ViewWeekIcon } from "./view_week.svg";
import { ReactComponent as SchemaIcon } from "./schema.svg";
import { ReactComponent as Groups2Icon } from "./groups_2.svg";
import { ReactComponent as ReduceCapacityIcon } from "./reduce_capacity.svg";
import { ReactComponent as TaskIcon } from "./task.svg";
import { ReactComponent as EditIcon } from "./edit.svg";
import { ReactComponent as DeleteIcon } from "./delete.svg";
import { ReactComponent as AddIcon } from "./add.svg";
import { ReactComponent as PendingActionsIcon } from "./pending_actions.svg";
import { ReactComponent as Assignment2Icon } from "./assignment_2.svg";
import { ReactComponent as ProblemIcon } from "./problem.svg";
import { ReactComponent as SummarizeIcon } from "./summarize.svg";
import { ReactComponent as ContextualTokenIcon } from "./contextual_token.svg";
import { ReactComponent as StacksIcon } from "./stacks.svg";
import { ReactComponent as CategoryIcon } from "./category.svg";
import { ReactComponent as TableViewIcon } from "./table_view.svg";
import { ReactComponent as CloseIcon } from "./close.svg";
import { ReactComponent as EventIcon } from "./event.svg";
import { ReactComponent as EventListIcon } from "./event_list.svg";
import { ReactComponent as VisibilityIcon } from "./visibility.svg";
import { ReactComponent as MarkEmailReadIcon } from "./mark_email_read.svg";
import { ReactComponent as AdsClickIcon } from "./ads_click.svg";
import { ReactComponent as ArrowBackIcon } from "./arrow_back.svg";
import { ReactComponent as Graph6Icon } from "./graph_6.svg";
import { ReactComponent as PartnerExchangeIcon } from "./partner_exchange.svg";
import { ReactComponent as HandshakeIcon } from "./handshake.svg";
import { ReactComponent as PersonIcon } from "./person.svg";
import { ReactComponent as StackedEmailIcon } from "./stacked_email.svg";
import { ReactComponent as ReceiptIcon } from "./receipt.svg";
import { ReactComponent as ManageAccountsIcon } from "./manage_accounts.svg";
import { ReactComponent as PasskeyIcon } from "./passkey.svg";
import { ReactComponent as ApartmentIcon } from "./apartment.svg";
import { ReactComponent as LockPersonIcon } from "./lock_person.svg";
import { ReactComponent as ReceipLongIcon } from "./receipt_long.svg";
import { ReactComponent as CollectionsBookmarkIcon } from "./collections_bookmark.svg";
import { ReactComponent as QuizIcon } from "./quiz.svg";
import { ReactComponent as AdGroupIcon } from "./ad_group.svg";
import { ReactComponent as ReportIcon } from "./report.svg";
import { ReactComponent as ViewListIcon } from "./view_list.svg";
import { ReactComponent as RateReviewIcon } from "./rate_review.svg";
import { ReactComponent as LabelIcon } from "./label_.svg";
import { ReactComponent as AnalyticsIcon } from "./analytics.svg";
import { ReactComponent as DocsIcon } from "./docs.svg";

export const Icons = {
  ArrowBackIcon,
  MarkEmailReadIcon,
  VisibilityIcon,
  CloseIcon,
  AddIcon,
  EditIcon,
  DeleteIcon,
  GroupIcon,
  LisenceIcon,
  AssignmentIcon,
  LogoutIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  UnfoldMoreIcon,
  AdminPanelSettingsIcon,
  NotificationsIcon,
  MonitoringIcon,
  AccountTreeIcon,
  ListAltIcon,
  MoreVertIcon,
  DirectionsBoatIcon,
  SupervisorAccountIcon,
  Diversity3Icon,
  BoltIcon,
  SocialLeaderboardIcon,
  AwardStarIcon,
  ContractIcon,
  ContractEditIcon,
  ManufacturingIcon,
  NotificationsMultipleIcon,
  TvSigninIcon,
  CalendarMonthIcon,
  ViewWeekIcon,
  SchemaIcon,
  Groups2Icon,
  ReduceCapacityIcon,
  TaskIcon,
  PendingActionsIcon,
  Assignment2Icon,
  ProblemIcon,
  SummarizeIcon,
  ContextualTokenIcon,
  StacksIcon,
  CategoryIcon,
  TableViewIcon,
  EventIcon,
  EventListIcon,
  AdsClickIcon,
  Graph6Icon,
  PartnerExchangeIcon,
  HandshakeIcon,
  PersonIcon,
  StackedEmailIcon,
  ReceiptIcon,
  ManageAccountsIcon,
  PasskeyIcon,
  ApartmentIcon,
  LockPersonIcon,
  ReceipLongIcon,
  CollectionsBookmarkIcon,
  QuizIcon,
  AdGroupIcon,
  ReportIcon,
  ViewListIcon,
  RateReviewIcon,
  LabelIcon,
  DocsIcon,
  AnalyticsIcon,
};
